import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postResubmitWorkflow = createApi(`ResubmitWorkflowSlice`,"POST");

const ResubmitWorkflowSlice = createSlice({
  name: 'ResubmitWorkflowSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postResubmitWorkflow.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postResubmitWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postResubmitWorkflow.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ResubmitWorkflowSlice.reducer;